import { render, staticRenderFns } from "./problemStatistics.vue?vue&type=template&id=6fb50f83&scoped=true"
import script from "./problemStatistics.vue?vue&type=script&lang=js"
export * from "./problemStatistics.vue?vue&type=script&lang=js"
import style0 from "./problemStatistics.vue?vue&type=style&index=0&id=6fb50f83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb50f83",
  null
  
)

export default component.exports